import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';
import { Colors } from '../../../themes/colors';

export const AppleIcon: React.FC<IconProps> = ({
  size = 24,
  color = Colors.role.textStrong,
  style,
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    overflow="visible"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path d="M15.9 0H15.7C14.4 0.2 13.1 0.9 12.3 1.8C11.5 2.7 10.8 3.9 10.9 5.6C12.7 5.7 13.8 4.8 14.6 3.9C15.4 3 16 1.7 15.9 0Z" fill={color} />
    <Path d="M21 17.6V17.5C19.3 16.8 17.9 15.4 17.7 13.1C17.5 10.5 18.8 9 20.4 8C19.5 6.8 18.2 5.9 16.3 5.7C14.9 5.4 13.8 5.9 12.7 6.3C12.6 6.3 12.5 6.3 12.4 6.4C12.3 6.4 12.2 6.4 12.1 6.5C11.8 6.6 11.5 6.7 11.2 6.7C10.7 6.7 10.2 6.5 9.8 6.3C9.7 6.3 9.5 6.2 9.4 6.2C8.9 6 8.3 5.8 7.7 5.7C6.3 5.5 5.1 6 4.1 6.5C2.4 7.6 1.1 9.7 1 12.4V13.4C1.3 17.1 2.7 20 4.6 22.3C5.2 23 6.1 23.8 7.1 24H7.6C8.2 23.9 8.8 23.7 9.3 23.5C10 23.3 10.7 23 11.6 23C12.4 23 13 23.3 13.5 23.5C14.1 23.7 14.8 24 15.5 24C17.1 24 18.1 22.7 18.8 21.7C18.9 21.6 18.9 21.6 18.9 21.5C19.8 20.3 20.5 19.1 21 17.6Z" fill={color} />
  </Svg>
);

AppleIcon.displayName = 'AppleIcon';
